export enum GcpNeedFromCloudEnum {
  ALIGN_SALES_OR_ACCOUNT = 'Align sales/account strategy',
  ALREADY_IN_TOUCH_WITH_GCS = 'Already in touch with Google Cloud sales',
  TECHNICAL_SUPPORT = 'Technical support',
  TRANSACTION_RELATED = 'Transaction related support',
  RENEWAL = 'Upselling/renewal/cross-selling support',
  USE_OPP_SUMMARY = 'Use Opportunity Summary field for explanation',
  OTHER = 'Other',
}
